
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Grid2 } from '@mui/material';
import Container from '@mui/material/Container';
import {  CGRedirectButton } from '../elements/CGLinkButton';


export default function Content() {


  return (
    <React.Fragment>
      <Container maxWidth="xl" sx={{ my: 5 }}>
        <Grid2 container justifyContent={'space-between'}>
          <Grid2 size={{ xs: 12 }}>
            {/* <Typography variant='h4'>Callgoose SQIBS</Typography> */}
            <Typography sx={{ color: 'text.secondary' }}>
              <CGRedirectButton href={process.env.REACT_APP_HOME} target="_blank">
                Callgoose SQIBS
              </CGRedirectButton> is a comprehensive solution for businesses seeking to streamline operations through automation and advanced incident management. By reducing manual efforts, ensuring faster resolutions, and enabling real-time responses, this platform enhances operational resilience and efficiency, making it an invaluable asset across industries.

              For more insights on transforming your business operations, explore
              <CGRedirectButton href={process.env.REACT_APP_HOME + '/callgoose-sqibs'} target="_blank">Callgoose SQIBS Incident Management
              </CGRedirectButton> and <CGRedirectButton href={process.env.REACT_APP_HOME + '/platform/automation'} target="_blank">Callgoose SQIBS Automation</CGRedirectButton>.
              <br />
              <br />
              <CGRedirectButton href={process.env.REACT_APP_HOME} target="_blank">
                Callgoose SQIBS
              </CGRedirectButton>  is a cutting-edge automation platform designed to elevate your organization’s resilience, reliability, and operational
              efficiency. With powerful On-Call scheduling, real-time <CGRedirectButton href={process.env.REACT_APP_HOME + '/callgoose-sqibs'} target="_blank">Incident Management</CGRedirectButton> ,
              and Incident Response capabilities, it ensures your systems are always on and responsive. Whether you need <CGRedirectButton href={process.env.REACT_APP_HOME + '/platform/automation/process-automation'} target="_blank">Process Automation</CGRedirectButton>
              , <CGRedirectButton href={process.env.REACT_APP_HOME + '/platform/automation/runbook-automation'} target="_blank">Runbook Automation</CGRedirectButton>,

              <CGRedirectButton href={process.env.REACT_APP_HOME + '/platform/automation'} target="_blank">Incident Auto-remediation</CGRedirectButton>,
              <CGRedirectButton href={process.env.REACT_APP_HOME + '/platform/automation'} target="_blank">IT request automation</CGRedirectButton>, or
              <CGRedirectButton href={process.env.REACT_APP_HOME + '/platform/automation'} target="_blank">Event-Driven Automation</CGRedirectButton>, Callgoose SQIBS empowers
              you with comprehensive solutions. Stay connected and in control with notifications via Mobile App (Android, iPhone), Email, SMS, 
              Phone Calls in over <CGRedirectButton href={process.env.REACT_APP_HOME} target="_blank">30+ languages</CGRedirectButton> across <CGRedirectButton href={process.env.REACT_APP_HOME} target="_blank">200+ countries</CGRedirectButton>, and seamless <CGRedirectButton href={process.env.REACT_APP_HOME + '/callgoose-sqibs'} target="_blank">integrations</CGRedirectButton> with Slack & Microsoft Teams.
              Empower your team to trigger, acknowledge, and resolve incidents directly from Slack & Microsoft Teams. Discover why <CGRedirectButton href={process.env.REACT_APP_HOME} target="_blank">Callgoose SQIBS</CGRedirectButton> is the superior PagerDuty alternative in the market.


              <br />
              <br />

              By leveraging these tools and using  <CGRedirectButton href={process.env.REACT_APP_HOME + '/callgoose-sqibs'} target="_blank">Callgoose SQIBS Incident Management
              </CGRedirectButton> and <CGRedirectButton href={process.env.REACT_APP_HOME + '/platform/automation'} target="_blank">
                Callgoose SQIBS Automation Platform
              </CGRedirectButton>, you can set up robust event-driven automation workflows to enhance efficiency, reliability, and responsiveness in your IT operations.
            </Typography>

          </Grid2>
        </Grid2>
      </Container>
    </React.Fragment>
  );
}
